<template>
  <div class="container-fluid">
    <div class="panel panel-info">
      <div style="text-align: left;margin:20px;margin-left:10px;margin-right:0px;" class=" ">
        <h5>Request for medical Certificate 
           <b-button class="float-right" @click="handleback" variant="danger">
              <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill> Back
            </b-button>
        </h5>
        <hr/>
      </div>
      <div class="panel-body">
        <div>
          <div class="md-4">
            <b-card
              class="mb-3"
              style="height: 160px"
            >
              <b-card-text class="mycard">
                <div class="row">
                  <div class="col-6" style="font-size:18px;font-family:Arial;font-weight:bold">Date</div>
                  <div class="col-4">12-04-2020</div>
                  <div class="col-2">
                    <b-dropdown
                      size="sm"
                      variant="link"
                      dropleft text="Drop-Left"
                      toggle-class="text-decoration-none"
                      no-caret
                     
                    >
                      <template #button-content>
                       <b-icon-three-dots-vertical></b-icon-three-dots-vertical><span class="sr-only">Action</span>
                      </template>
                      <b-dropdown-item @click="viewHandle">View</b-dropdown-item>
                      <b-dropdown-item href="#">Edit</b-dropdown-item>
                      <b-dropdown-item href="#">Delete</b-dropdown-item>
                    </b-dropdown>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6" style="font-size:18px;font-family:Arial;font-weight:bold">Tag No</div>
                  <div class="col-4">44</div>
                  <div class="col-2"></div>
                </div>
                <div class="row">
                  <div class="col-6" style="font-size:18px;font-family:Arial;font-weight:bold">Owner Name</div>
                  <div class="col-6">Rajesh Sharma</div>
                </div>
                <div class="row">
                  <div class="col-6" style="font-size:18px;font-family:Arial;font-weight:bold">City</div>
                  <div class="col-4">Solapur</div>
                  <div class="col-2"></div>
                </div><br/>
             
              </b-card-text>
            </b-card>
          </div>
          <div class="md-4">
            <b-card
              class="mb-3"
              style="height: 160px"
            >
              <b-card-text class="mycard">
                <div class="row">
                  <div class="col-6" style="font-size:18px;font-family:Arial;font-weight:bold">Date</div>
                  <div class="col-4">12-04-2020</div>
                  <div class="col-2">
                    <b-dropdown
                      size="sm"
                      variant="link"
                      dropleft text="Drop-Left"
                      toggle-class="text-decoration-none"
                      no-caret
                     
                    >
                      <template #button-content>
                       <b-icon-three-dots-vertical></b-icon-three-dots-vertical><span class="sr-only">Action</span>
                      </template>
                      <b-dropdown-item @click="viewHandle">View</b-dropdown-item>
                      <b-dropdown-item href="#">Edit</b-dropdown-item>
                      <b-dropdown-item href="#">Delete</b-dropdown-item>
                    </b-dropdown>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6" style="font-size:18px;font-family:Arial;font-weight:bold">Tag No</div>
                  <div class="col-4">44</div>
                  <div class="col-2"></div>
                </div>
                <div class="row">
                  <div class="col-6" style="font-size:18px;font-family:Arial;font-weight:bold">Owner Name</div>
                  <div class="col-6">Ramesh kale</div>
                </div>
                <div class="row">
                  <div class="col-6" style="font-size:18px;font-family:Arial;font-weight:bold">City</div>
                  <div class="col-4">Solapur</div>
                  <div class="col-2"></div>
                </div><br/>
                <div class="row">
                 
                </div>
              </b-card-text>
            </b-card>
          </div>
          <div class="md-4">
            <b-card
              class="mb-3"
              style="height: 160px"
            >
              <b-card-text class="mycard">
                <div class="row">
                  <div class="col-6" style="font-size:18px;font-family:Arial;font-weight:bold">Date</div>
                  <div class="col-4">12-04-2020</div>
                  <div class="col-2">
                    <b-dropdown
                      size="sm"
                      variant="link"
                      dropleft text="Drop-Left"
                      toggle-class="text-decoration-none"
                      no-caret
                     
                    >
                      <template #button-content>
                       <b-icon-three-dots-vertical></b-icon-three-dots-vertical><span class="sr-only">Action</span>
                      </template>
                      <b-dropdown-item @click="viewHandle">View</b-dropdown-item>
                      <b-dropdown-item href="#">Edit</b-dropdown-item>
                      <b-dropdown-item href="#">Delete</b-dropdown-item>
                    </b-dropdown>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6" style="font-size:18px;font-family:Arial;font-weight:bold">Tag No</div>
                  <div class="col-4">44</div>
                  <div class="col-2"></div>
                </div>
                <div class="row">
                  <div class="col-6" style="font-size:18px;font-family:Arial;font-weight:bold">Owner Name</div>
                  <div class="col-6">Rakesh Patil</div>
                </div>
                <div class="row">
                  <div class="col-6" style="font-size:18px;font-family:Arial;font-weight:bold">City</div>
                  <div class="col-4">Solapur</div>
                  <div class="col-2"></div>
                </div><br/>
                
                  
              
              </b-card-text>
            </b-card>
          </div>

          <b-card no-body class="overflow-hidden" style="max-width: 540px">
            <b-row no-gutters> </b-row>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    viewHandle(){
      this.$router.push('/home/medical')
    },
    handleback(){
      this.$router.go(-1);
    },
  },
};
</script>

<style>
table {
  font-family: arial, sans-serif;
  line-height: 1;
  width: 100%;
}

td,
th {
  border: 0px solid #dddddd;
  text-align: left;
  padding: 2px;
}
.mycard {
  padding-top: 5px !important;
  padding-bottom: 5px;
}
  .btn {
  background-color: DodgerBlue;
  border: none;
  color: white;
  padding: 12px 16px;
  font-size: 16px;
  cursor: pointer;
}

body {
  line-height: 1;
}
</style>
